import React from 'react';
import PropTypes from 'prop-types';
import { isDev } from '../Utils';
export const ListBuilder = ({
	List,
	total,
	start,
	currentPage,
	builderClick,
}) => {
	return new Array(total).fill().map((v, index) => {
		const final = start + index;
		const isActive = currentPage && currentPage === final;
		return (
			<List
				key={final}
				children={final}
				active={isActive}
				onClick={builderClick(final)}
			/>
		);
	});
};

export const Ul = ({ className, children }) => (
	<ul className={className}>{children}</ul>
);

export const Li = ({ children, active, disabled, onClick, title }) => {
	return (
		<li className={`${active ? 'active' : disabled ? 'disabled' : ''}`}>
			{active || disabled ? (
				<span>{children}</span>
			) : (
				<a href='/#' title={title} onClick={onClick}>
					{children}
				</a>
			)}
		</li>
	);
};

if (isDev) {
	ListBuilder.propTypes = {
		List: PropTypes.elementType.isRequired,
		total: PropTypes.number.isRequired,
		start: PropTypes.number.isRequired,
		currentPage: PropTypes.number,
		builderClick: PropTypes.func.isRequired,
	};

	Ul.propTypes = {
		className: PropTypes.string,
		children: PropTypes.arrayOf(PropTypes.element).isRequired,
	};

	Li.propTypes = {
		active: PropTypes.bool,
		disabled: PropTypes.bool,
		title: PropTypes.string,
		onClick: PropTypes.func,
		children: PropTypes.any.isRequired,
	};
}
